(function () {
    "use strict";

    angular
        .module("app")
        .directive("developerTypeAhead", ["PatternService", developerTypeAhead]);

    function developerTypeAhead(patternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return patternService.searchDevelopers(searchText, scope.brandId, scope.roleId).then(function (response) {
                        return response ? response : [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.DeveloperId;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "=", brandId: "=", roleId: "@" },
            template: '<input' +
                ' uib-typeahead="item.FullName for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/> <i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();
